import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Seo } from './core/seo';
import { ORGANISATION_LD, WEBSITE_LD } from './core/structured-data';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  template: `
    <app-header />
    <main id="main">
      <router-outlet />
    </main>
    <app-footer />
    <a class="wa-float"
       href="https://wa.me/918983643660?text=Hi%20Mechtron%2C%20I%20need%20a%20treatment%20plant%20quote"
       target="_blank" rel="noopener noreferrer"
       aria-label="Chat with Mechtron on WhatsApp">
      <img src="/assets/images/Whatsapp.svg" alt="" width="56" height="56" aria-hidden="true">
    </a>
  `
})
export class App implements OnInit {
  private readonly seo = inject(Seo);

  ngOnInit(): void {
    // Site-wide graph; page components add their own Product/Breadcrumb nodes.
    this.seo.setJsonLd('ld-organisation', ORGANISATION_LD);
    this.seo.setJsonLd('ld-website', WEBSITE_LD);
  }
}
